<template>
  <div class="discovery-throbber">
    <div class="discovery-throbber-container">
      <div class="discovery-throbber-anim"></div>
      <div class="discovery-throbber-label">Loading...</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ThrobberWidget',
};
</script>

<style scoped lang="less">
@import '~@/css/global';
.discovery-throbber {
  position: absolute;
  inset: 0;
  pointer-events: none;
  display: grid;
  place-items: start center;
  text-align: center;
  z-index: 10;
  background: rgba(255,255,255,0.85);
}
.discovery-throbber-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #333;
  text-align: center;
  color: white;
  width: 150px;
  height: 150px;
  border-radius: 75px;
  opacity: 0.5;
}
.discovery-throbber-anim {
  background: url('@/img/book-animation.webp') left center;
  -webkit-animation: book-anim 0.8s steps(12) infinite;
  animation: book-anim 0.8s steps(12) infinite;
  -ms-transform: scale(0.5);
  transform: scale(0.5);
  width: 200px;
  height: 150px;
  position: relative;
  top: -25px;
  left: -25px;
  margin: 0 auto -40px;
}
@keyframes book-anim{
  to{ background-position:-2400px }
}
.discovery-throbber-label {
  position: relative;
  top: -10px;
}
</style>
